import { useTheme } from 'styled-components';
import Highcharts from 'highcharts';
import { AssetClassDTO } from '../../ManageExcessCashModal.meta';
import { useEffect, useState } from 'react';

interface UsePortfolioGroupChartParams {
  data: AssetClassDTO[];
  assetAllocationList: AssetClassDTO[];
}

export const usePortfolioGroupChart = ({
  data,
  assetAllocationList,
}: UsePortfolioGroupChartParams) => {
  const theme = useTheme();
  const [seriesData, setSeriesData] = useState<any[]>();

  useEffect(() => {
    if (data) {
      const updatedAssetAllocationList = assetAllocationList
        .map(asset => {
          const match = data.find(value => value.id === asset.id);
          return match && match.y ? { name: asset.name, y: match.y, color: asset.color } : null;
        })
        .filter(item => item !== null);
      setSeriesData(updatedAssetAllocationList);
    }
  }, [data]);

  const customSettings: Highcharts.Options = {
    title: { y: 18 },
    chart: {
      height: 200,
    },
    plotOptions: {
      pie: {
        size: '90%',
        states: {
          hover: {
            enabled: true,
          },
        },
      },
    },
  };

  return {
    data: {
      customSettings,
      series: seriesData
        ? [
            {
              data: seriesData,
            },
          ]
        : null,
    },
  };
};
